'use strict';

// Map the criterium with thier parent module before they get deleted if no data
function mappingModules () {
  window.moduleMapping = {};

  $('.module').each(function () {
    var $this = $(this);
    return $this.find('.criterium').each(function () {
      var $subObj = $(this);
      window.moduleMapping[$subObj.attr('id')] = $this.attr('id');
    });
  });
}

module.exports = mappingModules;
